(function(){
  /* 日程の正本（2026-09-13改訂・敬老の日=9/21(月・祝)）
     注文の締切は設けない。毎日発送。
     9/20(日)17:00＝敬老の日にお渡しになる方への「ご注文の目安」（2026-09-19 にゃんさん実測）
       ※ヤマト運輸で大阪・和泉市から翌日配送できる地域に限る
     銀行振込＝入金確認後の発送。土日は確認が遅れるのでカードを勧める
     9/23(水)＝連休の最終日（価格の期限ではない。在庫がなくなり次第終了）
     ※ phase名 'cardonly' は目安日当日(9/18)を指す。CSSの data-ph と対応 */
  var bankEnd =new Date('2026-09-19T23:59:59+09:00');
  var deadline=new Date('2026-09-20T17:00:00+09:00');
  var lateEnd =new Date('2026-09-23T23:59:59+09:00');
  var root=document.querySelector('.tnk');
  function phaseOf(now){
    if(now<=bankEnd) return 'pre';
    if(now<=deadline) return 'cardonly';
    if(now<=lateEnd) return 'late';
    return 'after';
  }
  function tick(){
    var now=new Date(), ph=phaseOf(now), sp=window.innerWidth<641;
    if(root && root.getAttribute('data-phase')!==ph){ root.setAttribute('data-phase',ph); }
    var el=document.getElementById('tnk-cd');
    var diff=deadline-now, d=Math.floor(diff/86400000), h=Math.floor(diff%86400000/3600000), m=Math.floor(diff%3600000/60000);
    var rest = (d>0 ? d+'日'+h+'時間' : h+'時間'+m+'分');
    if(el){
      if(ph==='pre'){
        el.innerHTML = sp
          ? '敬老の日に渡すなら <b>9/20(日)17時まで</b>｜あと'+rest+'・毎日発送'
          : 'まだ間に合います。<b>敬老の日(9/21)にお渡しになるなら 9/20(日) 17時まで のご注文が目安</b>です（あと'+rest+'／大阪から翌日お届けできる地域に限ります）';
      }else if(ph==='cardonly'){
        el.innerHTML = sp
          ? '<b>本日17時まで</b>のご注文が敬老の日の目安｜あと'+h+'時間'+m+'分'
          : 'まだ間に合います。<b>敬老の日(9/21)にお渡しになるなら、本日17時まで</b>のご注文が目安です（あと'+h+'時間'+m+'分／大阪から翌日お届けできる地域に限ります）';
      }else if(ph==='late'){
        el.innerHTML = sp
          ? '<b>連休中も毎日発送</b>｜ご実家へ直送も承ります'
          : '<b>連休中も毎日発送</b>しています。連休中のお届けも、ご実家への直送も承ります';
      }else{
        el.innerHTML='<b>毎日発送</b>しています。ご注文から1〜2日でお届けします（全国送料無料・のし無料）';
      }
    }
    /* 追従CTAの左側も同期（価格行は残し、下の1行だけ日程で差し替える） */
    var sb=document.querySelector('#tnk-sticky [data-tnk-sb]');
    if(sb){
      if(ph==='pre'){        sb.textContent='送料無料・のし無料／9/20(日)17時まで'; }
      else if(ph==='cardonly'){ sb.textContent='送料無料・のし無料／本日17時まで'; }
      else if(ph==='late'){  sb.textContent='送料無料・のし無料／連休中も毎日発送'; }
      else{                  sb.textContent='税込・送料無料／のし・包装も無料'; }
    }
  }
  tick();setInterval(tick,30000);

  /* 追従CTA: スクロール毎のレイアウト計算をやめ、IntersectionObserverで判定
     (offsetTop/offsetHeightの読み取りは毎フレームreflowを起こし、
      アプリ内ブラウザでスクロールがカクつく原因になる) */
  try{
    var sticky=document.getElementById('tnk-sticky');
    var hero=document.querySelector('.tnk-hero');
    if(sticky&&hero&&'IntersectionObserver' in window){
      new IntersectionObserver(function(es){
        es.forEach(function(e){
          if(e.isIntersecting){sticky.classList.remove('on')}else{sticky.classList.add('on')}
        });
      },{rootMargin:'-80px 0px 0px 0px',threshold:0}).observe(hero);
    }
  }catch(e){}

  /* 商品タイプの絞り込み */
  try{
    var tabs=[].slice.call(document.querySelectorAll('.tnk-tab'));
    var cards=[].slice.call(document.querySelectorAll('#tnk-gridwrap .tnk-card'));
    var nohit=document.getElementById('tnk-nohit');
    var sep=document.querySelector('#tnk-gridwrap .tnk-grid-sep');
    var hit=document.getElementById('tnk-hit');
    var resetBtn=document.getElementById('tnk-freset');
    var resets=[].slice.call(document.querySelectorAll('.tnk-freset'));
    var curT='all', curC='all';
    function apply(){
      var shown=0, shownAvail=0;
      cards.forEach(function(c){
        var ok=(curT==='all'||c.getAttribute('data-type')===curT)&&(curC==='all'||c.getAttribute('data-color')===curC);
        c.style.display=ok?'':'none';
        if(ok){shown++;if(!/is-sold/.test(c.className)){shownAvail++}}
      });
      if(sep){sep.style.display=(shown-shownAvail)>0?'':'none'}
      if(hit){hit.textContent=shown}
      if(nohit){nohit.style.display=shown?'none':'block'}
      if(resetBtn){resetBtn.hidden=(curT==='all'&&curC==='all')}
    }
    tabs.forEach(function(tab){
      tab.addEventListener('click',function(){
        var f=tab.getAttribute('data-filter'), c=tab.getAttribute('data-color');
        var grp=(f!==null)?'data-filter':'data-color';
        tabs.forEach(function(t){if(t.getAttribute(grp)!==null){t.setAttribute('aria-selected',t===tab?'true':'false')}});
        if(f!==null){curT=f}else{curC=c}
        apply();
      });
    });
    resets.forEach(function(b){b.addEventListener('click',function(){
      curT='all';curC='all';
      tabs.forEach(function(t){var v=t.getAttribute('data-filter')||t.getAttribute('data-color');t.setAttribute('aria-selected',v==='all'?'true':'false')});
      apply();
      var el=document.getElementById('tnk-filters');
      if(el){el.scrollIntoView({behavior:'smooth',block:'center'})}
    })});
  }catch(e){}

  /* スクロールリビール(上品なフェードアップ+時差) */
  try{
    var okReveal = ('IntersectionObserver' in window)
      && !matchMedia('(prefers-reduced-motion: reduce)').matches
      && window.innerWidth > 900;   /* モバイルは演出を切ってスクロール優先 */
    if(okReveal){
      var groups=['.tnk-trust-item','.tnk-sec .tnk-eyebrow','.tnk-sec .tnk-h2','.tnk-sec .tnk-lede',
        '.tnk-card','.tnk-split>*','.tnk-gift-item','.tnk-faq-item','.tnk-pair-price','.tnk-tagline'];
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}});
      },{threshold:.05,rootMargin:'300px 0px -4% 0px'});
      groups.forEach(function(sel){
        document.querySelectorAll(sel).forEach(function(el){
          var idx=0,p=el.parentElement;
          if(p){idx=Array.prototype.indexOf.call(p.children,el)}
          el.classList.add('rv');
          el.style.transitionDelay=Math.min(idx%6,5)*90+'ms';
          io.observe(el);
        });
      });
    }
  }catch(e){}

  /* 商品ストリップの自動スクロール（2026-09-13）
     ・横スワイプできることを見せるため、ゆっくり右へ流す（約30px/秒）
     ・触った/ホバーしたら止め、5秒後に再開。画面外・タブ非表示・reduce-motion では動かさない
     ・末尾に1周分を複製して途切れなく回す。scrollLeft をずらすだけで DOM もレイアウトも触らない */
  try{
    var strip=document.getElementById('tnk-strip');
    var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(strip&&!reduce&&'IntersectionObserver' in window&&strip.scrollWidth>strip.clientWidth+40){
      var orig=[].slice.call(strip.children), n=orig.length;
      orig.forEach(function(el){var c=el.cloneNode(true);c.setAttribute('aria-hidden','true');c.setAttribute('tabindex','-1');strip.appendChild(c)});
      var loopW=0, SPEED=30, pos=0, raf=0, last=0, visible=false, paused=false, resumeT=0;
      function measure(){loopW=strip.children[n].offsetLeft-strip.children[0].offsetLeft}
      measure();
      function step(ts){
        if(!visible||paused||document.hidden){raf=0;return}
        if(last){pos+=SPEED*Math.min(ts-last,64)/1000; if(loopW&&pos>=loopW){pos-=loopW} strip.scrollLeft=pos}
        last=ts; raf=requestAnimationFrame(step);
      }
      function start(){if(!raf){pos=strip.scrollLeft;last=0;strip.classList.add('auto');raf=requestAnimationFrame(step)}}
      function stop(){if(raf){cancelAnimationFrame(raf);raf=0}strip.classList.remove('auto')}
      function hold(ms){paused=true;stop();clearTimeout(resumeT);resumeT=setTimeout(function(){paused=false;if(visible)start()},ms)}
      strip.addEventListener('touchstart',function(){hold(5000)},{passive:true});
      strip.addEventListener('wheel',function(){hold(5000)},{passive:true});
      strip.addEventListener('pointerdown',function(e){if(e.pointerType!=='touch')hold(5000)},{passive:true});
      strip.addEventListener('pointerenter',function(e){if(e.pointerType==='mouse')hold(60000)});
      strip.addEventListener('pointerleave',function(e){if(e.pointerType==='mouse')hold(800)});
      new IntersectionObserver(function(es){es.forEach(function(e){visible=e.isIntersecting;if(visible&&!paused){start()}else{stop()}})},{threshold:0}).observe(strip);
      document.addEventListener('visibilitychange',function(){if(!document.hidden&&visible&&!paused)start()});
      window.addEventListener('resize',measure);
    }
  }catch(e){}
})();
